require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-126-teamgantt-app-for-android.json") })
        }
      }, "path---article-126-teamgantt-app-for-android");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-126-teamgantt-app-for-android!./.cache/json/article-126-teamgantt-app-for-android.json
// module id = 481
// module chunks = 231608221292675